import { defineComponent as _defineComponent } from 'vue'
import coinify from 'coinify';
import { CoinifyCurrency } from 'ah-api-gateways';
import { computed } from 'vue';
import TextBlockWithOverflowTooltip from 'ah-common-lib/src/text/TextBlockWithOverflowTooltip.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CurrencyInfoTableCell',
  props: {
  currency: {
    type: String,
    required: true,
  },
  highlighted: { type: [Boolean, String], default: false },
  showLabels: { type: [Boolean, String], default: false },
},
  setup(__props) {

const props = __props;



const currencyObject = computed(() => coinify.get(props.currency) as CoinifyCurrency);

return { __sfc: true,props, currencyObject, TextBlockWithOverflowTooltip }
}

})